import React from 'react';

// Apple allows us to use their logo in white or black only
enum AppleColors {
  white = '#FFF',
  black = '#000',
}

interface AppleLogoSvgProps {
  color?: AppleColors;
  size?: string;
}

export const AppleLogoSvg = ({
  color = AppleColors.black,
  size = '56px',
}: AppleLogoSvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" fillRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" clipRule="evenodd" viewBox="0 0 84 84" height={size} width={size}>
    <path color={color} fillRule="nonzero" d="M42.596 20.354c3.467 0 7.812-2.416 10.4-5.637 2.342-2.917 4.05-7 4.05-11.075 0-.55-.046-1.104-.146-1.559-3.858.15-8.496 2.667-11.279 6.042-2.196 2.563-4.2 6.592-4.2 10.717 0 .604.1 1.208.15 1.408.242.054.633.104 1.025.104ZM30.388 81.25c4.737 0 6.833-3.271 12.745-3.271 6.005 0 7.321 3.167 12.596 3.167 5.175 0 8.642-4.929 11.917-9.758 3.658-5.542 5.175-10.975 5.271-11.225-.342-.1-10.25-4.28-10.25-16.005 0-10.166 7.808-14.75 8.25-15.1-5.18-7.65-13.042-7.85-15.188-7.85-5.812 0-10.546 3.625-13.525 3.625-3.225 0-7.471-3.425-12.5-3.425-9.571 0-19.287 8.155-19.287 23.555 0 9.562 3.612 19.679 8.058 26.22C22.283 76.721 25.6 81.25 30.388 81.25Z" />
  </svg>
);

